import { render, staticRenderFns } from "./TheLayoutArea.vue?vue&type=template&id=532daf83&scoped=true"
import script from "./TheLayoutArea.vue?vue&type=script&lang=ts"
export * from "./TheLayoutArea.vue?vue&type=script&lang=ts"
import style0 from "./TheLayoutArea.vue?vue&type=style&index=0&id=532daf83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532daf83",
  null
  
)

export default component.exports